import styled from 'styled-components'

interface IWithTaxTooltipStyledProps {}

export const WithTaxTooltipStyled = styled.div<IWithTaxTooltipStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  padding: ${(props) => props.theme.space.medium};
`
